import { extractWhsFromOtcSalesChannelId, isOtcSalesChannelId } from '../../constants/otc';

export default {
  activeWhs: (state, getters, rootState) => {
    const existing = state?.activeFilters?.whs?.[0];
    if (existing) return existing;
    const salesChannelId = rootState.core?.salesChannel?.salesChannelId;
    if (!isOtcSalesChannelId(salesChannelId)) return undefined;
    const derived = extractWhsFromOtcSalesChannelId(salesChannelId);
    return derived || undefined;
  },
};
